/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BpToCaseResourcesBasicDto } from '../../models/bp-to-case-resources-basic-dto';

export interface GetAllCaseResourcesByTccRole$Params {
}

export function getAllCaseResourcesByTccRole(http: HttpClient, rootUrl: string, params?: GetAllCaseResourcesByTccRole$Params, context?: HttpContext): Observable<StrictHttpResponse<BpToCaseResourcesBasicDto>> {
  const rb = new RequestBuilder(rootUrl, getAllCaseResourcesByTccRole.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BpToCaseResourcesBasicDto>;
    })
  );
}

getAllCaseResourcesByTccRole.PATH = '/case-resources/basic';
